// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensorySessionStatus } from './FoodSensorySessionStatus';
import { operatorId } from './Operator';
import { foodSensoryPacing } from './FoodSensoryPacing';
import { foodSensoryLook } from './FoodSensoryLook';
import { z } from 'zod';
export const foodSensorySessionId = (z.number());
export const foodSensorySession = z.object({
    id: foodSensorySessionId,
    name: z.string().nullable(),
    status: foodSensorySessionStatus,
    planned_date: z.date().nullable(),
    instructions: z.string().nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    pacing: foodSensoryPacing,
    duplicated_from_id: foodSensorySessionId.nullable(),
    look: foodSensoryLook,
    started_at: z.date().nullable(),
    stage_blank: z.boolean(),
    presenter_notes_lobby: z.string().nullable(),
    presenter_notes_finale: z.string().nullable(),
    intake_for_operators: z.boolean(),
    join_code: z.string(),
});
export const foodSensorySessionInitializer = z.object({
    id: foodSensorySessionId.optional(),
    name: z.string().optional().nullable(),
    status: foodSensorySessionStatus.optional(),
    planned_date: z.date().optional().nullable(),
    instructions: z.string().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    pacing: foodSensoryPacing.optional(),
    duplicated_from_id: foodSensorySessionId.optional().nullable(),
    look: foodSensoryLook.optional(),
    started_at: z.date().optional().nullable(),
    stage_blank: z.boolean().optional(),
    presenter_notes_lobby: z.string().optional().nullable(),
    presenter_notes_finale: z.string().optional().nullable(),
    intake_for_operators: z.boolean().optional(),
    join_code: z.string().optional(),
});
export const foodSensorySessionMutator = z.object({
    id: foodSensorySessionId.optional(),
    name: z.string().optional().nullable(),
    status: foodSensorySessionStatus.optional(),
    planned_date: z.date().optional().nullable(),
    instructions: z.string().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    pacing: foodSensoryPacing.optional(),
    duplicated_from_id: foodSensorySessionId.optional().nullable(),
    look: foodSensoryLook.optional(),
    started_at: z.date().optional().nullable(),
    stage_blank: z.boolean().optional(),
    presenter_notes_lobby: z.string().optional().nullable(),
    presenter_notes_finale: z.string().optional().nullable(),
    intake_for_operators: z.boolean().optional(),
    join_code: z.string().optional(),
});
//# sourceMappingURL=FoodSensorySession.js.map